import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VDateInput } from 'vuetify/labs/components'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import i18n from './i18n'
import { useI18n } from 'vue-i18n'
import { blurNumberInputOnWheel } from './disableNumberInputWheel'

const savedTheme = localStorage.getItem('theme')
const defaultTheme = ['light', 'dark', 'system'].includes(savedTheme) ? savedTheme : 'system'

export default createVuetify({
  components: { ...components, VDateInput },
  directives,
  defaults: {
    VTextField: {
      onWheel: blurNumberInputOnWheel,
    },
  },
  theme: {
    defaultTheme,
    themes: {
      light: {
        dark: false,
        colors: {
          // jemné podbarvení řádků kalendáře (odpovídá původním rgba na bílém)
          'calendar-entry': '#EDFBF2',
          'calendar-absence': '#F3EDFC',
          // světle modré pozadí karet přihlášky
          'entry-surface': '#EDF5FF',
          'tab-divider': '#FFFFFF',
          // stavové řádky ve stepperu startovky/výsledky
          'upload-ok': '#E8F5E9',
          'upload-create': '#FFF3E0',
          'upload-empty': '#FFEBEE',
          // hromadná přihláška — původní green-lighten-4 / green-darken-1 / orange-lighten-2
          'bulk-row-selected': '#C8E6C9',
          'bulk-checkbox-on': '#43A047',
          'bulk-checkbox-off': '#FFCC80',
          // sloupec Body v žebříčcích
          'ranking-points': '#FDEAC8',
          // výsledky — označený řádek / recent
          'results-highlight': '#E3F2FD',
          'results-recent': '#FFE0B2',
          // banner online výsledků na homepage
          'live-banner-from': '#FFA450',
          'live-banner-to': '#FFCAA8',
          'live-banner-icon': '#2E7D32',
          link: '#1867C0',
          'link-hover': '#0a58ca',
        },
      },
      dark: {
        dark: true,
        colors: {
          background: '#121212',
          surface: '#212121',
          // tmavší primary než výchozí Vuetify dark (app bar, tlačítka)
          primary: '#2a6fdb',
          // stejný odstín, namíchaný na tmavé pozadí
          'calendar-entry': '#334D3C',
          'calendar-absence': '#382B4F',
          'entry-surface': '#1E2A3A',
          'tab-divider': '#000000',
          // výchozí Vuetify dark error (#CF6679) je na btn příliš světlý
          error: '#E53935',
          // tmavé varianty stavových řádků (kontrast k on-surface)
          'upload-ok': '#1B3D24',
          'upload-create': '#4A3218',
          'upload-empty': '#4A1F24',
          // hromadná přihláška — tmavé varianty (ne zasahovat do background přes :global)
          'bulk-row-selected': '#1B3D24',
          'bulk-checkbox-on': '#2E7D32',
          'bulk-checkbox-off': '#EF6C00',
          // sloupec Body — stejný oranžový odstín, tmavý pro bílý text
          'ranking-points': '#4A3518',
          'results-highlight': '#1A3A5C',
          // recent result — zlatavý jantar (ne bahnitá oranžovohnědá)
          'results-recent': '#5C4E22',
          // banner online výsledků na homepage
          'live-banner-from': '#6B4520',
          'live-banner-to': '#4A3018',
          'live-banner-icon': '#81C784',
          // světlejší modrá pro kontrast odkazů na tmavém pozadí
          link: '#90CAF9',
          'link-hover': '#BBDEFB',
        },
      },
    },
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n, useScope: 'global' }),
    locale: i18n.global.locale.value,
    fallback: 'en',
  },
})
